/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Flyerentityimages2Inputs */

const en_flyerentityimages2 = /** @type {(inputs: Flyerentityimages2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Existing images`)
};

const de_flyerentityimages2 = /** @type {(inputs: Flyerentityimages2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vorhandene Bilder`)
};

/**
* | output |
* | --- |
* | "Existing images" |
*
* @param {Flyerentityimages2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const flyerentityimages2 = /** @type {((inputs?: Flyerentityimages2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Flyerentityimages2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_flyerentityimages2(inputs)
	return de_flyerentityimages2(inputs)
});
export { flyerentityimages2 as "flyerEntityImages" }